import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { theme } from 'styles/theme/hav-theme'
import { shouldForwardProp } from 'commons/utils/mui'

type StyledButtonProps = {
  height: number
  active: boolean
  disabled?: boolean
}

export const StyledButton = styled('button', { shouldForwardProp })<StyledButtonProps>`
  display: flex;
  align-items: center;
  width: fit-content;
  border: none;
  border-radius: 500px;
  padding: 0 ${theme.spacing.md};
  height: ${({ height }) => `${height}px`};
  transition: background-color 0.2s;
  background-color: transparent;

  ${({ active }) =>
    active
      ? css`
          border: 1.5px solid ${theme.colors.primary.main};
          color: ${theme.colors.primary.main};
          background-color: ${theme.colors.quartenary};
        `
      : css`
          border: 1.5px solid ${theme.colors.neutral.clear};
          color: ${theme.colors.neutral.light};

          :hover {
            background-color: ${theme.colors.quartenary};
          }
        `}

  :disabled {
    cursor: default;
    background-color: ${theme.colors.neutral.lighthover};
    pointer-events: none;
  }
`

export const ButtonText = styled.span`
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2xs']};
  line-height: ${theme.typography.lineHeight.sm};
  color: inherit;
`
